import { render, staticRenderFns } from "./packageInfo.vue?vue&type=template&id=26b05309&scoped=true&"
import script from "./packageInfo.vue?vue&type=script&lang=js&"
export * from "./packageInfo.vue?vue&type=script&lang=js&"
import style0 from "./packageInfo.vue?vue&type=style&index=0&id=26b05309&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b05309",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26b05309')) {
      api.createRecord('26b05309', component.options)
    } else {
      api.reload('26b05309', component.options)
    }
    module.hot.accept("./packageInfo.vue?vue&type=template&id=26b05309&scoped=true&", function () {
      api.rerender('26b05309', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/openapi/packageInfo.vue"
export default component.exports